<div class="error-message-container" aria-live="assertive" tabindex="-1" #container>
  <i class="allycon-error-fill text-danger" aria-hidden="true"></i>
  {{ message }}
</div>
